import { z } from 'zod';
import { BusinessChoiceType, FlowChoiceType } from 'features/utils/types';
import { addressDetailStateSchema } from './addressDetailsStateSchema';
import { mapDetailSchema } from './mapDetailSchema';
import { extraServiceSchema } from './extraServiceSchema';

export const answerStateSchema = z.object({
  businessChoice: z.nativeEnum(BusinessChoiceType),
  flowChoice: z.nativeEnum(FlowChoiceType),
  address: z.string().optional(),
  addressDetails: addressDetailStateSchema.optional(),
  panelId: z.string().optional(),
  roofType: z.string().optional(),
  roofAngle: z.number().optional(),
  consumption: z.number().optional(),
  billAmount: z.number().optional(),
  needBattery: z.boolean().optional(),
  needVehicle: z.boolean().optional(),
  inverter: z.string().optional(),
  counter: z.string().optional(),
  mapDetail: mapDetailSchema.optional(),
  numPanelsExplicit: z.number().optional(),
  extraServices: extraServiceSchema.array().optional(),
});

export type AnswersState = z.infer<typeof answerStateSchema>;
